import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error("No session in callback URL");
      navigate("/admin/login");
      return;
    }
    (async () => {
      try {
        await exchangeGoogleSession(decodeURIComponent(m[1]));
        toast.success("Signed in with Google");
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Sign-in failed");
        navigate("/admin/login");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0B] text-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="animate-spin mx-auto" size={28} />
        <p className="mt-4 text-sm text-white/70">Signing you in…</p>
      </div>
    </div>
  );
}
